export default function getCountryCode(locale: string): string {
    return locale === 'en' ? 'gb' : locale
}
